import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { RSFSettings } from './rsf-settings';

@Injectable({
  providedIn: 'root'
})
export class RsfSettingsService extends BaseService<RSFSettings, number> {

  constructor(
    protected override injector: Injector,
  ) {
    super(injector, '/RSFSettings');
  }

  save(rsfSettings: RSFSettings[]) {
    return this.http.put<RSFSettings[]>(this.URL + '/Save', rsfSettings);
  }
}
